import { ForecasterProjectionChart } from '../../../../shared/components/ForecasterProjectionChart';
import { ForecasterProjectionDisclosuresFragment } from '../../../../shared/graphql/forecasterProjectionDisclosures.generated';
import { PurposeRetirementIncome } from '../../../data';

type Props = {
  purpose: PurposeRetirementIncome;
  disclosures: ForecasterProjectionDisclosuresFragment;
};

export const RetirementIncomeProjection = ({ disclosures, purpose }: Props) => {
  const { retirementIncomeProjection: projection } = purpose;
  const timeSeries = projection.balanceTimeSeries;
  if (!timeSeries) return null;

  return <ForecasterProjectionChart targetAmount={undefined} disclosures={disclosures} timeSeries={timeSeries} />;
};
